import React from 'react';
import PageMenu from './PageMenu';

function MenuFind(props) {
  return (
    <PageMenu
      {...props}
      title="Find Your Home"
      items={[
        {
          name: 'communities',
          title: 'Our Communities',
          keepParams: true,
        },
        {
          name: 'homes',
          title: 'Our Condos',
          keepParams: true,
        },
      ]}
    />
  );
}

export default MenuFind;



// WEBPACK FOOTER //
// ./src/components/MenuFind.js